module.exports = __webpack_public_path__ + "assets/img/dzh-20.dcedb264.jpg";